import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMazdaComponent } from './simple-icons-mazda.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMazdaComponent ],
    exports:      [ SimpleIconsMazdaComponent ],
    bootstrap:    []
})
export class SimpleIconsMazdaModule {}
